var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DetailsDisplayView',{attrs:{"itemId":_vm.itemId,"isDisplay":_vm.isDisplay,"selectedInspectionIds":_vm.selectedInspectionIds,"totalItems":_vm.totalItems},on:{"click":_vm.withButtonPressed,"withButtonPressed":_vm.withButtonPressed,"withValue":_vm.withValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }